import { render, staticRenderFns } from "./mudarsenha.vue?vue&type=template&id=7370ece2&scoped=true&"
import script from "./mudarsenha.vue?vue&type=script&lang=js&"
export * from "./mudarsenha.vue?vue&type=script&lang=js&"
import style0 from "./mudarsenha.vue?vue&type=style&index=0&id=7370ece2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7370ece2",
  null
  
)

export default component.exports